import { useState } from 'react'

export const useMarkdown = (defaultState: string = '') => {
  const [markdown, setMarkdown] = useState<{ markdown: string }>({ markdown: defaultState })
  return {
    markdown,
    setMarkdown,
  }
}
